import React, { PropTypes } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import FontIcon from 'material-ui/FontIcon'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import FlatButton from 'material-ui/FlatButton';
import HeaderImage from './rc-white-logo-2.png';

import { Grid, Row, Col } from 'react-bootstrap'
import { Link, browserHistory } from 'react-router'
import MediaQuery from 'react-responsive'

import { paths } from '../../routes'



const styles = {
    appbarsmall: {
        backgroundColor: '#4B8CC2',
        width: '100%'
        // '100vh'
    },

    headerimage: {
        height: 55
    }
}

const Header = ({authenticated, signOut, children}) => {
  return (
    <div>
      <header>
            <AppBar className="front"
                    style={styles.appbarsmall}
                    //title="Riteclass"
                    title={<img style={styles.headerimage} src={HeaderImage} />}
                    iconElementRight={authenticated ? <FlatButton onClick={signOut} label="Sign Out" /> : null}

                    iconElementLeft={<IconMenu
                              className="mobile"
                              iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                              anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                              targetOrigin={{horizontal: 'left', vertical: 'top'}} >
                                <Link to={paths.ON_OFF_CAMPUS}>
                                    <MenuItem leftIcon={<FontIcon className="material-icons">place</FontIcon>}>Housing Location</MenuItem>
                                </Link>
                                  <Link to={paths.HOUSING_GROUP}>
                                      <MenuItem leftIcon={<FontIcon className="material-icons">group</FontIcon>}>Housing Group</MenuItem>
                                  </Link>
                                  <Link to={paths.HOUSING_PREFERENCES}>
                                      <MenuItem leftIcon={<FontIcon className="material-icons">format_list_bulleted</FontIcon>}>Housing Preferences</MenuItem>
                                  </Link>
                                  <Link to={paths.HOUSING_RESULTS}>
                                      <MenuItem leftIcon={<FontIcon className="material-icons">home</FontIcon>}>Your Housing</MenuItem>
                                  </Link>
                                  <Link to={paths.MEAL_PLAN}>
                                      <MenuItem leftIcon={<FontIcon className="material-icons">local_dining</FontIcon>}>Meal Plan</MenuItem>
                                  </Link>
                              </IconMenu>}
            />

            <Grid>
                <Row className="show-grid">
                    <Col xsHidden md={4}>
                        <Drawer>
                            <div className="top">
                              <Link to={paths.ON_OFF_CAMPUS}>
                                  <MenuItem primaryText="Housing Location" leftIcon={<FontIcon className="material-icons">place</FontIcon>} />
                              </Link>
                                <Link to={paths.HOUSING_GROUP}>
                                    <MenuItem primaryText="Housing Group" leftIcon={<FontIcon className="material-icons">group</FontIcon>} />
                                </Link>
                                <Link to={paths.HOUSING_PREFERENCES}>
                                    <MenuItem primaryText="Housing Preferences" leftIcon={<FontIcon className="material-icons"><i class="material-icons">format_list_bulleted</i></FontIcon>} />
                                </Link>
                                <Link to={paths.HOUSING_RESULTS}>
                                    <MenuItem primaryText="Your Housing" leftIcon={<FontIcon className="material-icons">home</FontIcon>} />
                                </Link>
                                <Link to={paths.MEAL_PLAN}>
                                    <MenuItem leftIcon={<FontIcon className="material-icons">local_dining</FontIcon>}>Meal Plan</MenuItem>
                                </Link>

                            </div>
                        </Drawer>
                    </Col>
                </Row>
            </Grid>

        </header>
        <div>{children}</div>
  </div>
  );
};

Header.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/views/components/header/index.js